import axios from 'axios'
import qs from 'qs'
import router from '@/router/index'
import Vue from 'vue'

// const apps = process.env.APP_CONFIG

// Add a response interceptor
axios.interceptors.response.use(function (response) { // 响应拦截
  Vue.$vux.loading.hide()
  return response
}, function (error) {
  Vue.$vux.loading.hide()
  const { status, data, statusText } = error.response
  const msg = data.errorMessage || data.message || statusText
  if ((status === 400 && data.errorCode === '400sec-core-301')) {
    Vue.$vux.toast.text(msg, 'middle')
    router.push('/login', () => {
      location.reload()
    })
  } else if (status === 401) {
    router.push('/login', () => {
      location.reload()
    })
  } else if (status >= 400) {
    Vue.$vux.toast.text(msg, 'middle')
  }
  // Do something with response error
  return Promise.reject(error.response)
})

export default {
  request: function (api, params = {}, headers) {
    if (api.mock && api.mock.enable === true) { // 模拟响应数据
      console.log('mock data: ', api, params)
      return Promise.resolve(api.mock.data)
    }
    // const app = apps[api.app || 'psxt'] // 获取api对应的app配置
    const config = {
      // baseURL: app.baseUrl,
      url: api.path,
      method: api.method || 'POST', // 请求方法
      timeout: api.timeout || 0, // 0 默认不设置超时
      withCredentials: true, // 跨域时是否进行请求头认证
      responseType: api.dataType || 'text', // 响应数据格式
      validateStatus: function (status) { // 校验响应状态，用来区分是请求成功还是失败
        return status < 400
      },
      headers: {
        'CS-PLATFORM': 'mobile',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': api.contentType || 'application/x-www-form-urlencoded',
        'Accept': '*/*',
        tenantId: params.tenantId || null
      }
    }
    if (headers) {
      Object.keys(headers).forEach((key) => {
        config.headers[key] = headers[key]
      })
    }

    if (config.method.toUpperCase() === 'GET') {
      config.params = params
    } else {
      if (api.contentType === 'multipart/form-data;charset=UTF-8' || api.contentType === 'application/json') {
        config.data = params
      } else {
        config.data = params
        config.transformRequest = [function (data) {
          return qs.stringify(data)
        }]
      }
    }
    let $http = axios(config)
    const { loading = {} } = api
    loading && Vue.$vux.loading.show({
      text: loading ? loading.text || '数据加载中' : ''
    })
    return $http
  }
}



// WEBPACK FOOTER //
// ./src/apis/index.js